import { Navigate } from "@tanstack/react-router";
import { useAuth } from "@/hooks/useAuth";

export function IndexRouteComponent() {
  const { session, isAdmin } = useAuth();

  if (!session || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/overview" search={{ period: "30d" }} replace />;
}
